<template>
  <el-form-item
    :label="$t('VEHCILE_NAME')"
    :prop="prop"
    v-loading="vehicleLoading"
    element-loading-spinner="el-icon-loading"
  >
    <el-select
      :disabled="disabled"
      :placeholder="$t('SELECT_PLACEHOLDER')"
      v-model="selectValue"
      :multiple="multiple"
      :collapseTags="collapseTags"
      clearable
      filterable
      @change="handleChange"
      @clear="handleClear"
      @blur="handleBlur"
      @visible-change="handleVisibleChange"
    >
      <el-option-group
        v-for="group in carList"
        :key="group.id"
        :label="$i18n.locale == 'fa' ? group.fa_title : group.en_title"
      >
        <el-option
          v-for="item in group.vehicles"
          :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id"
        ></el-option>
      </el-option-group>
    </el-select>
  </el-form-item>
</template>

<script>
import { carsList } from '@/api/global'

export default {
  name: 'VehicleGroupSelect',
  props: {
    prop: {
      type: String,
      default: 'vehicle.id',
    },
    model: {
      type: [String, Number, Array],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    collapseTags: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      carList: [],
      selectValue: this.model,
      vehicleLoading: true,
    }
  },

  methods: {
    handleChange(value) {
      this.selectValue = value
      this.$emit('update', value)
    },
    handleClear() {
      this.selectValue = this.multiple ? [] : null
      this.$emit('clear')
      this.$emit('update', this.selectValue)
    },
    handleBlur() {
      this.$emit('blur')
    },
    handleVisibleChange(visible) {
      // When dropdown closes (visible becomes false), emit blur event
      if (!visible) {
        this.$emit('blur')
      }
    },
    loadCarList() {
      this.vehicleLoading = true
      carsList
        .api()
        .then((res) => {
          if (res) {
            this.carList = res
            this.vehicleLoading = false
          }
        })
        .catch((error) => {
          console.error('Error loading car list:', error)
          this.vehicleLoading = false
        })
    },
  },
  watch: {
    model: {
      handler(newVal) {
        this.selectValue = newVal
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.loadCarList()
  },
}
</script>
